import React from 'react';
import Label from "components/general/Label"

export default function NotAvailable({ label = "LabelNoDataAvailableResultPage" }) {

  return (
    <div>
      <em>
        <Label data={label} />
      </em>
    </div>
  )
}
